import React from 'react';
export function CampaignLandingPageIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 2H5a3 3 0 00-3 3v14a3 3 0 003 3h14a3 3 0 003-3V5a3 3 0 00-3-3zM5 4h14a1 1 0 011 1v3H4V5a1 1 0 011-1zm14 16H5a1 1 0 01-1-1v-9h16v9a1 1 0 01-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7a1 1 0 100-2 1 1 0 000 2zM9 7a1 1 0 100-2 1 1 0 000 2zM12 7a1 1 0 100-2 1 1 0 000 2z"
  }));
}